export default () => {
  const animatedTexts = document.querySelectorAll('.animated__text');

  const init = (el) => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          el.classList.add('visible');
        }
      });
    }, { rootMargin: '0px', threshold: 0.2 });
  
    observer.observe(el);
  };
  
  const animatedComponent = () => {
    const animatedComp = document.querySelectorAll("[data-animation]");
  
    animatedComp.forEach(el => {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            el.classList.add("animation--active");
          }
        });
      }, { rootMargin: '0px', threshold: 0.2 });
  
      observer.observe(el);
    });
  };
  
  animatedTexts.forEach(el => init(el));
  animatedComponent();  
}